import { MessageType } from '../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons';

function MessageHeader(props: {
    messageSelector: (message: MessageType) => void;
    message: MessageType;
    selected: boolean;
}) {
    const envelopeIcon = () => {
        if (props.message.read) {
            return <FontAwesomeIcon icon={faEnvelopeOpen} />;
        } else {
            return <FontAwesomeIcon icon={faEnvelope} />;
        }
    };

    return (
        <div
            onClick={() => props.messageSelector(props.message)}
            className="group flex text-sm md:text-base justify-between p-1 rounded-lg h-16 items-center"
        >
            <div
                className={`
                ${
                    props.message.read ? 'font-semibold' : 'font-bold'
                }`}
            >
                {props.message.title}
            </div>
            <div
                className={`text-primary
                ${
                    props.message.read ? 'text-stone-300 ' : ''
                }`}
            >
                {envelopeIcon()}
            </div>
        </div>
    );
}

export default MessageHeader;
